import useSWRImmutable from 'swr/immutable'
import { Link, useLocation } from 'react-router-dom'

import Loading from '../../components/layout/Loading'
import { getCheckoutSuccess } from '../../../api/payment'
import Button from '../../components/form/Button'
import CheckedIcon from '../../../assets/icons/checked.svg?react'
import { useI18N } from '../../../libraries/i18n/hook'
import { useAuth } from '../../../libraries/auth'
import BloomLogo from '../../../assets/bloom-logo.svg?react'

const CheckoutSuccessPage = () => {
  const location = useLocation()
  const { t } = useI18N()
  const { isAuthenticated } = useAuth()
  const urlSearchParams = new URLSearchParams(location.search)
  const { data, isLoading, error } = useSWRImmutable(`payment/success/${urlSearchParams}`, () => getCheckoutSuccess(urlSearchParams.get('session_id') ?? ''))

  if(isLoading) { return <Loading /> }
  if(error) { return <div>Error loading checkout success. {error?.message}</div> }
  if(!data) { return <div>Empty checkout success</div> }

  return (
    <div className='mt-4 flex flex-col items-center justify-center gap-y-8 h-screen'>
      <div className='flex justify-center items-center flex-col'>
          <BloomLogo className='logo h-12 w-auto' />
        </div>
      <p className='flex items-center gap-x-2'><CheckedIcon className='w-8 h-8 stroke-deep-green' />{t('checkout.success')}</p>
      <Button>{!isAuthenticated ? <Link to='/login'>{t('auth.login.or.signup')}</Link> : <Link to='/'>{t('common.go.home')}</Link>}</Button>
    </div>
  )
}

export default CheckoutSuccessPage
